<template>
    <div>
        <div v-if="bill.state === 'COMPLETED'">
            <h3 class="text-5 mb-3">Ticket Purchase Receipt</h3>

            <div class="table-responsive mb-4">
                <table class="table table-bordered">
                    <tbody>
                        <tr>
                            <td class="text-muted">Tickets</td>
                            <td>
                                <strong>{{ bill.type }} x {{ bill.quantity }}</strong>
                            </td>
                        </tr>
                        <tr>
                            <td class="text-muted">Transaction Reference</td>
                            <td>
                                <strong>{{ transaction.customer_reference }}</strong>
                            </td>
                        </tr>
                        <tr v-if="bill.message">
                            <td class="text-muted">Message</td>
                            <td><strong>{{ bill.message }}</strong></td>
                        </tr>
                        <tr>
                            <td class="text-muted">Recipient</td>
                            <td>
                                <strong>{{ bill.phone || bill.email }}</strong><br>
                                <span v-if="transaction.sms && transaction.sms.delivered" class="badge badge-success">SMS Delivered</span>
                                <span v-else class="badge badge-warning">SMS Pending Delivery</span>
                            </td>
                        </tr>
                        <tr>
                            <td class="text-muted">Amount Paid</td>
                            <td>
                                <strong>{{ transaction.payment_currency }} {{ money(transaction.amount) }}</strong>
                            </td>
                        </tr>
                        <tr v-if="transaction.payment_type ==='App\\EcocashPayment'">
                            <td class="text-muted">Payment Reference</td>
                            <td><strong>{{ payment.ecocash_reference }}</strong></td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div v-if="bill.tickets && bill.tickets.length > 0" class="row mt-4">
                <div class="col-12">
                    <h4 class="text-4 mb-3">Download Your Tickets</h4>
                    <div class="table-responsive">
                        <table class="table table-bordered">
                            <thead>
                                <tr>
                                    <th>Ticket</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="ticket in bill.tickets" :key="ticket.id">
                                    <td class="text-muted">{{ bill.type }}</td>
                                    <td>
                                        <a :href="getTicketUrl(ticket.pdf)"
                                           target="_blank"
                                           class="btn btn-sm btn-primary ">
                                            <i class="fas fa-download mr-1"></i> Download Ticket
                                        </a>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>



            <div class="form-group mt-5">
                <button @click="submit" :class="['btn btn-success btn-block' , loading ? 'btn-loading' : '']">
                    Refresh
                </button>
            </div>
        </div>
        <div v-if="bill.state === 'PENDING-PAYMENT'">
            <h3 class="text-5 text-center mb-5">Awaiting Payment </h3>
            <div
                class="text-center text-primary text-20 line-height-07 mb-5 d-flex justify-content-center align-items-center">
                <div class="loader"></div>
            </div>
            <p v-if="countDown > 0" class="text-center text-primary text-8 line-height-07 mb-5">
                {{ this.countDown }}
            </p>
            <p class="text-center text-4 mb-5">Waiting for you to complete your payment</p>
            <p class="text-center text-1">To quickly check progress click below.</p>
            <div class="form-group">
                <button @click="submit" :class="['btn btn-success btn-block' , loading ? 'btn-loading' : '']">Refresh
                </button>
            </div>
        </div>
        <div v-if="init || processingStates.includes(bill.state)">
            <h3 class="text-5 text-center mb-5">Purchasing Ticket ... </h3>
            <div
                class="text-center text-primary text-20 line-height-07 mb-5 d-flex justify-content-center align-items-center">
                <div class="loader"></div>
            </div>
            <p v-if="countDown > 0" class="text-center text-primary text-8 line-height-07 mb-5">
                {{ this.countDown }}
            </p>
            <p class="text-center text-4 mb-5">Your Payment was successful we are preparing your ticket(s)</p>
            <p class="text-center text-1">To quickly check progress click below.</p>
            <div class="form-group">
                <button @click="submit" :class="['btn btn-success btn-block' , loading ? 'btn-loading' : '']">Refresh
                </button>
            </div>
        </div>
        <div v-if="bill.state === 'AIRTIME-FAILED'">
            <h3 class="text-5 text-center mb-5">Ticket Purchase Receipt</h3>

            <p class="text-center text-4 mb-5">
                Oops! Looks like the Gift Card system is a little unstable right now and your recharge may take longer
                to
                be delivered. You do not have to do anything. You will receive the recharge as soon as it becomes
                available. This usually takes at most 1 hour. Contact Magetsi Support if you need any assistance.
            </p>

            <div class="row">
                <p class="col-sm-4 text-muted text-sm-right font-weight-500 mb-0 mb-sm-3">Ref : </p>
                <p class="col-sm-8 font-weight-500">{{ transaction.customer_reference }}</p>
            </div>
            <div v-if="transaction.payment_type ==='App\\EcocashPayment'" class="row">
                <p class="col-sm-4 text-muted text-sm-right font-weight-500 mb-0 mb-sm-3">Payment Reference : </p>
                <p class="col-sm-8 font-weight-500">{{ payment.ecocash_reference }}</p>
            </div>

            <p class="text-center text-1">To quickly check progress click below.</p>
            <div class="form-group">
                <div class="row">
                    <div class="col-md-6">
                        <button @click.prevent="submit"
                                :class="['btn btn-success btn-block' , loading ? 'btn-loading' : '']">Refresh
                        </button>
                    </div>
                    <div class="col-md-6">
                        <router-link to="/gift-cards" class="btn btn-outline-primary btn-block">Close</router-link>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {money} from "../../../../core/forms/money";

export default {
    name: "ecocash.vue",
    mixins: [money],
    data() {
        return {
            rate: 0.6,
            bill: {},
            payment: {},
            transaction: {},
            loading: false,
            init: true,
            countDown: 5,
            ref: this.$route.query.id,
            processingStates: ['PAYMENT-COMPLETED', 'GENERATING-TICKET']
        };

    },
    methods: {
        getTicketUrl(pdfPath) {
            return `${window.location.origin}${pdfPath}`;
        },
        submit() {
            if (this.loading) {
                return;
            }

            this.loading = true;
            this.countDown = 0;

            // Check Payment

            window.axios['post'](`${window.location.origin}/tickets/complete`, {
                ref: this.ref
            }).then((response) => {

                this.init = false;
                if (response.data.success) {
                    this.bill = response.data.body.gift;
                    this.rate = response.data.body.rate || 0.6;
                    this.payment = response.data.body.payment;
                    this.transaction = response.data.body.transaction;
                    if (this.processingStates.includes(this.bill.state)) {
                        this.countDown = 30;
                        this.startCountDown();
                    }
                }

            }).finally(() => {
                this.loading = false;
            });


        },
        startCountDown() {
            if (this.countDown > 0) {
                setTimeout(() => {
                    this.countDown -= 1;
                    this.startCountDown();
                }, 1000);

            } else {

                if (!this.loading && !this.done) {
                    this.submit();
                }
            }
        },
    },

    mounted() {
        this.submit();
    }
}
</script>
